// src/autodesk_usage/components/corporate/CorporateMonthlyUsageChart.tsx
// All comments in English only
import ActiveLicenseUsageChart, {
  type UsageMode,
} from "./ActiveLicenseUsageChart";

interface Props {
  corporateName: string | string[];
  mode: UsageMode;
  startMonth: string;
  endMonth: string;
}

export default function CorporateMonthlyUsageChart({
  corporateName,
  mode,
  startMonth,
  endMonth,
}: Props) {
  return (
    <ActiveLicenseUsageChart
      scope="corporate"
      entityName={corporateName}
      title="Corporate Active licenses"
      mode={mode}
      startMonth={startMonth}
      endMonth={endMonth}
    />
  );
}
